import classes from '@/shared/ui/component-styles/HeaderIconButton.module.css'

interface HeaderIconButtonProps {
  ariaLabel: string
  onClick: () => void
  icon: React.ReactNode
}

export function HeaderIconButton({ ariaLabel, onClick, icon }: HeaderIconButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={classes.iconButton}
      onClick={onClick}
    >
      <div className={classes.iconButtonInner}>
        <span className={classes.icon}>{icon}</span>
      </div>
    </button>
  )
}
